import styled from 'styled-components';
import { FloatInput } from 'UI';

export const SInput = styled(FloatInput)`
  max-height: 28px;
`;

export const SClientGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(max(150px, calc(33.33% - 8px)), 100%), 1fr));
  gap: 8px;
`;
